import {
  MeetingStatus,
  ApprovalStatus,
  Auth0AccountRole,
} from "client/openapi";
import { useContext } from "react";
import { OrgRolesAndAccountContext } from "util/OrgRolesAccountContext";
import { Select } from "components/Select";

const approvalOptions = [
  { value: undefined, label: "Any" },
  { value: ApprovalStatus.APPROVED, label: "Approved" },
  { value: ApprovalStatus.PENDING, label: "Pending" },
  { value: ApprovalStatus.DENIED, label: "Denied" },
];

const meetingStatusOptions = [
  { value: MeetingStatus.ACCEPTED, label: "Accepted" },
  { value: MeetingStatus.PROPOSED, label: "Proposed" },
  { value: MeetingStatus.REJECTED, label: "Rejected" },
  { value: undefined, label: "Any" },
];

export function MeetingFilters({
  meetingStatusFilter,
  setMeetingStatusFilter,
  adminApprovalFilter,
  setAdminApprovalFilter,
  tutorApprovalFilter,
  setTutorApprovalFilter,
}: {
  meetingStatusFilter: MeetingStatus | undefined;
  setMeetingStatusFilter: (val: MeetingStatus | undefined) => void;
  adminApprovalFilter: ApprovalStatus | undefined;
  setAdminApprovalFilter: (val: ApprovalStatus | undefined) => void;
  tutorApprovalFilter: ApprovalStatus | undefined;
  setTutorApprovalFilter: (val: ApprovalStatus | undefined) => void;
}) {
  const labelClasses = "mr-2 text-sm font-medium";

  const { currently_selected_role } = useContext(OrgRolesAndAccountContext);
  const isAdmin = currently_selected_role === Auth0AccountRole.ORG_ADMIN;

  return (
    <div className="flex flex-col md:flex-row gap-4 items-center">
      <div className="flex items-center gap-2">
        <label className={labelClasses}>Reviewed by Admin:</label>
        <Select
          options={approvalOptions}
          value={approvalOptions.find(
            (opt) => opt.value === adminApprovalFilter
          )}
          onChange={(option) => setAdminApprovalFilter(option?.value)}
          className="w-32"
        />
      </div>

      <div className="flex items-center gap-2">
        <label className={labelClasses}>
          {isAdmin
            ? "Meeting Accepted by All Tutors:"
            : "Meeting Accepted by You:"}
        </label>
        <Select
          options={meetingStatusOptions}
          value={meetingStatusOptions.find(
            (opt) => opt.value === meetingStatusFilter
          )}
          onChange={(option) => setMeetingStatusFilter(option?.value)}
          className="w-32"
        />
      </div>

      <div className="flex items-center gap-2">
        <label className={labelClasses}>
          {isAdmin ? "Reviewed by All Tutors:" : "Reviewed by You:"}
        </label>
        <Select
          options={approvalOptions}
          value={approvalOptions.find(
            (opt) => opt.value === tutorApprovalFilter
          )}
          onChange={(option) => setTutorApprovalFilter(option?.value)}
          className="w-32"
        />
      </div>
    </div>
  );
}
